import { createUseStyles } from 'react-jss'
import { phonesDown, tabletDown } from '../../../../../../styles/const/breakpoints'

const useStyles = createUseStyles({
  graphContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  headingContainer: {
    marginBottom: 0
  },
  graphWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    flex: 1
  },
  legendContainer: {
    flex: 1,
    width: 190
  },
  [`@media screen and (${tabletDown})`]: {
    graphContainer: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  [`@media screen and (${phonesDown})`]: {
    graphContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    legendContainer: {
      flex: 'unset',
      width: 'unset',
      alignSelf: 'flex-start'
    },
    graphWrapper: {
      flexDirection: 'column',
      top: 'auto'
    }
  }
})

export default useStyles
